import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { Plus, History } from "lucide-react";
import { NewOrderDialog } from "./NewOrderDialog";
import { CustomerOrderHistoryDialog } from "./CustomerOrderHistoryDialog";
import {
  CASHIER, CALL_CENTER_ADMIN,
  AGENT
} from "../../common/SetupMasterEnum";

export function TopActionBar({ activeMode, onModeChange, currentOrder, isRecalledOrder, roleId, orderModes }) {
  const [isNewOrderOpen, setIsNewOrderOpen] = useState(false);
  const [isOrderHistoryOpen, setIsOrderHistoryOpen] = useState(false);
  const [preselectedOrderMode, setPreselectedOrderMode] = useState(null);
  const navigate = useNavigate();

  const handleOrderModeClick = (orderMode) => {
    setPreselectedOrderMode(orderMode.OrderModeId);
    setIsNewOrderOpen(true);
  };

  return (
    <div className="flex gap-2 p-4 border-b border-border bg-background items-center w-full justify-between">
      <div className="flex items-center justify-between w-full gap-4">
        {!isRecalledOrder && orderModes && orderModes.length > 0 && (
          <div className="flex gap-2">
            {orderModes.map((orderMode) => (
              <Button
                key={orderMode.OrderModeId}
                onClick={() => handleOrderModeClick(orderMode)}
                className="bg-primary text-primary-foreground hover:bg-primary/90"
                size="sm">
                <Plus className="h-4 w-4 mr-2" />
                {orderMode.OrderMode || `Order Mode ${orderMode.OrderModeId}`}
              </Button>
            ))}
          </div>
        )}

        <Button
          onClick={() => setIsOrderHistoryOpen(true)}
          className="bg-secondary text-secondary-foreground hover:bg-secondary/90"
          size="sm">
          <History className="h-4 w-4 mr-2" />
          Customer Order History
        </Button>

        <Button
          onClick={() => {
            if (roleId === AGENT) {
              navigate("/orders");

            }
            else {
              navigate("/OrderRecall");
            }
            return;
          }}
          className="bg-primary text-primary-foreground hover:bg-primary/90"
          size="sm">
          Recall Order List
        </Button>
      </div>

      <NewOrderDialog
        open={isNewOrderOpen}
        onOpenChange={(open) => {
          setIsNewOrderOpen(open);
          if (!open) {
            setPreselectedOrderMode(null);
          }
        }}
        onSubmit={(orderData) => {
          onModeChange(orderData);
          setIsNewOrderOpen(false);
          setPreselectedOrderMode(null);
        }}
        preselectedOrderMode={preselectedOrderMode}
      />

      <CustomerOrderHistoryDialog
        open={isOrderHistoryOpen}
        onOpenChange={setIsOrderHistoryOpen}
      />
    </div>
  );
}